import classNames from 'classnames';
import { PropsWithChildren, ReactNode, useContext } from 'react';

import { WithClassName } from '@types';
import { IntlContext } from '@utils/useIntl';

interface GalleryLayoutProps {
  elements: any;
  gap?: string;
  renderElement: (element: any, index: number) => ReactNode;
  nbPerRowDesktop?: number;
  nbPerRowTablet?: number;
  nbPerRowPhone?: number;
}

const GalleryLayout = ({
  className,
  elements,
  gap = 'gap-4',
  renderElement,
  nbPerRowDesktop = 6,
  nbPerRowTablet = 4,
  nbPerRowPhone = 2,
}: GalleryLayoutProps & WithClassName & PropsWithChildren) => {
  const { translate } = useContext(IntlContext);

  return elements.length ? (
    <div
      className={classNames('flex flex-wrap justify-center', className, gap)}
    >
      {elements.map((el, index) => (
        <div
          key={el.id}
          className={classNames(
            nbPerRowPhone === 6
              ? 'w-gallery-item-6'
              : nbPerRowPhone === 5
                ? 'w-gallery-item-5'
                : nbPerRowPhone === 4
                  ? 'w-gallery-item-4'
                  : nbPerRowPhone === 3
                    ? 'w-gallery-item-3'
                    : nbPerRowPhone === 2
                      ? 'w-gallery-item-2'
                      : 'w-gallery-item-1',
            nbPerRowTablet === 6
              ? 'tablet:w-gallery-item-6'
              : nbPerRowTablet === 5
                ? 'tablet:w-gallery-item-5'
                : nbPerRowTablet === 4
                  ? 'tablet:w-gallery-item-4'
                  : nbPerRowTablet === 3
                    ? 'tablet:w-gallery-item-3'
                    : nbPerRowTablet === 2
                      ? 'tablet:w-gallery-item-2'
                      : 'tablet:w-gallery-item-1',
            nbPerRowDesktop === 6
              ? 'desktop:w-gallery-item-6'
              : nbPerRowDesktop === 5
                ? 'desktop:w-gallery-item-5'
                : nbPerRowDesktop === 4
                  ? 'desktop:w-gallery-item-4'
                  : nbPerRowDesktop === 3
                    ? 'desktop:w-gallery-item-3'
                    : nbPerRowDesktop === 2
                      ? 'desktop:w-gallery-item-2'
                      : 'desktop:w-gallery-item-1',
          )}
        >
          {renderElement(el, index)}
        </div>
      ))}
    </div>
  ) : (
    <div className="text-center text-sm italic text-gray">
      {translate('gallery.empty')}
    </div>
  );
};

export default GalleryLayout;
